import styled, { css } from 'styled-components'

const CardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  & > * {
    width: ${({ itemsWidth }) => itemsWidth || '42.22vw'};
  }

  ${({ customStyles = '' }) => {
    return css`${customStyles}`
  }}
`

export default { CardsContainer }
